import { render, staticRenderFns } from "./TagUsagePie.vue?vue&type=template&id=2bdd829b"
import script from "./TagUsagePie.vue?vue&type=script&lang=ts"
export * from "./TagUsagePie.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports